export default __webpack_public_path__ + "static/EvergreenHero-MD-eb0f1b8c7e81f9dd0e774fdf06d371ea.webp";